const QUERIES = {
  UNIT_LIST: 'unit-list',
  PROCESS_LIST: 'process-list',
  PRODUCTS_LIST: 'products-list',
  SALES_ORDER_LIST: 'salesOrder-list',
  WORK_ORDER_LIST: 'workOrder-list',
  PURCHASE_ORDER_LIST: 'purchase-list',
  STAFF_LIST: 'staff-list',
  CUSTOMER_LIST: 'customer-list',
  VENDOR_LIST: 'vendor-list',
  RAWMATERIAL_LIST: 'rawmaterial-list',
  RAWMATERIAL_STOCK_LIST: 'rawmaterialStock-list',
  PRODUCTSTOCK_LIST: 'productstock-list',
  PAYMENT_LIST: 'payment-list',
  PURCHASERECEIVE_LIST: 'purchasereceive-list',
  SHIPMENT_LIST: 'shipment-list',
  PACKAGE_LIST: 'package-list',
  AGENT_LIST: 'agent-list',
  ACCOUNT_LIST: 'account-list',
  TERM_LIST: 'term_list',
  INVOICE: 'invoice_list',
  ACCOUNT_GROUP: 'account_group',
  BANK_ACCOUNT: 'bank_account',
  EMAIL_TEMPLATE: 'email_template',
  SO_SETTING: 'saleorder_setting',
  INVOICE_SETTING: 'invoice_setting',
  CREDIT_NOTE_SETTING: 'credit_note_setting',
  AUTONUMBERGENERATION: 'auto_number_generation',
  PO_SETTING: 'po_setting',
  EMAIL_SETTING: 'email_setting',
  CUSTOMER_VENDOR: 'customer_vendor',
  ORGANIZATION_PROFILE: 'organization_profile',
  GST_SETTING: 'gst_setting',
  TERM: 'term',
  PAYMENT_MODE: 'payment_mode',
  ROLE_LIST: 'role_list',
  EXPENSE: 'expense',
  EXPENSE_CATEGORY: 'expense-category',
  PRODUCT_LOW_STOCK: 'product-low-stock',
  STATUS_HISTORY: 'status-history',
  CATEGORY_LIST: 'category-list',
  BRAND_LIST: 'brand-list',
  MANUFACTURER_LIST: 'manufacturer-list',
  DESIGNNUMBER_LIST: 'designnumber-list',
  RAW_MATERIAL_PROCESS_LIST: 'rawmaterial-process-list',
  CASTING_ORDER_LIST: 'casting-order',
  CASTING_RECEIVE_LIST: 'casting-receive',
  KADI_FITTING_ORDER_LIST: 'kadi-fitting-list',
  POLISHING_ORDER_LIST: 'polishing-list',
  MOTI_PIROING_LIST: 'moti-piroing',
  MOTI_FITTING_LIST: 'moti-fitting',
  PROCESS_STOCK: 'process-stock',
  PASTING_LIST: 'pasting-list',
  PACKAGING_LIST: 'packaging-list',
};

export { QUERIES };
